<template>
    <Card>
        <div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">

                    <template slot-scope="{ row, index }" slot="cost_type">
                        <Select v-model="datas[index].cost_type" style="width:100px" :transfer='true'>
                            <Option v-for="item in costWayList" :value="item.value" :key="item.value">{{ item.label }}
                            </Option>
                        </Select>
                    </template>
                    <template slot-scope="{ row, index }" slot="price">
                        <Input v-model="datas[index].cost_money" style="width: 100px"/>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <Button type="primary" :data-index="index"  @click="save">编辑保存</Button>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
                      show-elevator/>
            </div>
        </div>
    </Card>
</template>
<script>
	import {
		getMediumCodeList,saveMediumCodeCost
	} from '@/api/runSet'
	import {mapGetters} from "vuex";

	export default {
        name: "cost_set",
        components: {},

        data() {
            return {
                costWayList: [
                    {value: 1, label: '固定成本'},
					{value: 2, label: '浮动成本'}
                ],
                count: 0,
                page: 1,
                datas: [],
                columns: [

                    {
                        "title": "媒体代码",
                        "key": "name"
                    },
                    {
                        "title": "所属渠道",
                        "key": "medium_name",
                    },

                    {
                        "title": "类型",
                        "key": "medium_type",
                    },
                    {
                        "title": "成本核算方式",
                        "slot": "cost_type",
                    },
                    {
                        "title": "价格",
                        "slot": "price",
                    },
                    {
                        "title": "操作",
                        "slot": "action",
                    },
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {
			this.getList();
		},
        methods: {
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				data.page = this.page;
				let res = await getMediumCodeList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			save(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				let data = that.datas[index]
				data.token = that.token;
				that.throttle(async function () {
					let res = await saveMediumCodeCost(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
        },

    }
</script>
<style scoped lang="less">

</style>
